/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Managelpspecificndas_Nolps5Inputs */

const en_coinvestments_managelpspecificndas_nolps5 = /** @type {(inputs: Coinvestments_Managelpspecificndas_Nolps5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must add organisations before adding specific NDAs`)
};

/**
* | output |
* | --- |
* | "You must add organisations before adding specific NDAs" |
*
* @param {Coinvestments_Managelpspecificndas_Nolps5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_managelpspecificndas_nolps5 = /** @type {((inputs?: Coinvestments_Managelpspecificndas_Nolps5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Managelpspecificndas_Nolps5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_managelpspecificndas_nolps5(inputs)
});
export { coinvestments_managelpspecificndas_nolps5 as "coInvestments_manageLpSpecificNdas_noLps" }